import yaml from "js-yaml";
import ar from './locals/ar'


export const t = (text) =>{

    return ar[text] ?? text;
}